import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Div = styled.div`
  height: 30px;
  ${({color}) => `color:` + color}
`;

class Tooltip extends PureComponent {
  render() {
    const {show, children, color} = this.props;
    if (show) {
      return <Div color={color}>{children}</Div>;
    } else {
      return null;
    }
  }
}

Tooltip.defaultProps = {
  color: 'black',
  show: false,
};

Tooltip.propTypes = {
  color: PropTypes.string,
  show: PropTypes.bool,
  children: PropTypes.any,
};

export default Tooltip;
